import {Component, OnInit} from '@angular/core';
import {LoginService} from '../login/login.service';
import {MenuService} from '../menu/menu.service';
import {ROUTER_DIRECTIVES} from '@angular/router';
import {FilterPipe} from './filtro';

declare var $: any;

@Component({
    selector: 'NavLeft',
    template: require('../../app/navLeft/navLeft.component.html'),
    styles: [require('../../app/navLeft/navLeft.component.css')],
    directives: [ROUTER_DIRECTIVES],
    pipes: [FilterPipe]
})

export class NavLeftComponent implements OnInit {
    showNavBar: boolean;
    menus: any;
    usuarioConectado: any;

    constructor(private loginService: LoginService,
                private menuService: MenuService) {
        this.showNavBar = this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword;
        this.loginService.logIn.subscribe((mode) => {
            this.showNavBar = mode && !this.loginService.getDecodeToken().cambiarPassword;
            if (mode == true) {
                this.usuarioConectado = this.loginService.getDecodeToken();
                this.menuService.getMenus().subscribe((menus) => {
                    this.menus = menus;
                });
            }
        });


    }

    ngOnInit() {
        if (this.showNavBar) {
            this.usuarioConectado = this.loginService.getDecodeToken();
            this.menuService.getMenus().subscribe((menus) => {
                this.menus = menus;
            });
        }

        //Ocultar la barra cuando hace click afuera
        $(document).bind("mouseup touchend", function (e) {
            var container = $("#menuDesplegable");
            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0
                && e.target.id != "itemCargaDatos" && e.target.className != "menuSeleccionable" && e.target.id != "dropdownCargaDatos"
                && e.target.id != "imgCargaDatos" && e.target.id != "spanCargaDatos" && e.target.id != "flechaCargaDatos") // ... nor a descendant of the container
            {
                $('#menuDesplegable').css("display", "none");
            }
        });
    }

    desplegarMenu() {
        if ($('#menuDesplegable').css("display") == "block")
            $('#menuDesplegable').css("display", "none");
        else
            $('#menuDesplegable').css("display", "block");
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/navLeft/navLeft.component.ts